import * as t from "./actionType";

const initialState = {
  // REPORT
  reportList: [],
  reportListLoading: false,
  reportData: [],
  reportDataLoading: false,
  reportCreate: [],
  reportCreateLoading: false,
  reportUpdate: [],
  reportUpdateLoading: false,
  reportDelete: [],
  reportDeleteLoading: false,
  reportRun: [],
  reportRunLoading: false,
  reportPdf: [],
  reportPdfLoading: false,
  reportSnapshotPdf: [],
  reportSnapshotPdfLoading: false,
  reportEmail: [],
  reportEmailLoading: false,
  // ITEM
  itemList: [],
  itemListLoading: false,
  itemData: [],
  itemDataLoading: false,
  itemCreate: [],
  itemCreateLoading: false,
  itemUpdate: [],
  itemUpdateLoading: false,
  itemDelete: [],
  itemDeleteLoading: false,
  // SNAPSHOT
  snapshotList: [],
  snapshotListLoading: false,
  snapshotData: [],
  snapshotDataLoading: false,
  snapshotDelete: [],
  snapshotDeleteLoading: false,
  // RESULT
  resultBySnapshot: [],
  resultBySnapshotLoading: false,
  resultByItem: [],
  resultByItemLoading: false,
  resultData: [],
  resultDataLoading: false,
  resultOrganic: [],
  resultOrganicLoading: false,
};

const Serp = (state = initialState, action) => {
  switch (action.type) {
    // ---------- REPORT ----------
    case t.SERP_REPORT_LIST:
      return { ...state, reportListLoading: true };
    case t.SERP_REPORT_LIST_SUCCESS:
      return { ...state, reportList: action.data, reportListLoading: false };
    case t.SERP_REPORT_LIST_FAIL:
      return { ...state, reportListLoading: false };

    case t.SERP_REPORT_DATA:
      return { ...state, reportDataLoading: true };
    case t.SERP_REPORT_DATA_SUCCESS:
      return { ...state, reportData: action.data, reportDataLoading: false };
    case t.SERP_REPORT_DATA_FAIL:
      return { ...state, reportDataLoading: false };

    case t.SERP_REPORT_CREATE:
      return { ...state, reportCreateLoading: true };
    case t.SERP_REPORT_CREATE_SUCCESS:
      return { ...state, reportCreate: action.data, reportCreateLoading: false };
    case t.SERP_REPORT_CREATE_FAIL:
      return { ...state, reportCreateLoading: false };
    case t.SERP_REPORT_CREATE_RESET:
      return { ...state, reportCreate: [] };

    case t.SERP_REPORT_UPDATE:
      return { ...state, reportUpdateLoading: true };
    case t.SERP_REPORT_UPDATE_SUCCESS:
      return { ...state, reportUpdate: action.data, reportUpdateLoading: false };
    case t.SERP_REPORT_UPDATE_FAIL:
      return { ...state, reportUpdateLoading: false };
    case t.SERP_REPORT_UPDATE_RESET:
      return { ...state, reportUpdate: [] };

    case t.SERP_REPORT_DELETE:
      return { ...state, reportDeleteLoading: true };
    case t.SERP_REPORT_DELETE_SUCCESS:
      return { ...state, reportDelete: action.data, reportDeleteLoading: false };
    case t.SERP_REPORT_DELETE_FAIL:
      return { ...state, reportDeleteLoading: false };
    case t.SERP_REPORT_DELETE_RESET:
      return { ...state, reportDelete: [] };

    case t.SERP_REPORT_RUN:
      return { ...state, reportRunLoading: true };
    case t.SERP_REPORT_RUN_SUCCESS:
      return { ...state, reportRun: action.data, reportRunLoading: false };
    case t.SERP_REPORT_RUN_FAIL:
      return { ...state, reportRunLoading: false };
    case t.SERP_REPORT_RUN_RESET:
      return { ...state, reportRun: [] };

    case t.SERP_REPORT_PDF:
      return { ...state, reportPdfLoading: true };
    case t.SERP_REPORT_PDF_SUCCESS:
      return { ...state, reportPdf: action.data, reportPdfLoading: false };
    case t.SERP_REPORT_PDF_FAIL:
      return { ...state, reportPdfLoading: false };
    case t.SERP_REPORT_PDF_RESET:
      return { ...state, reportPdf: [] };

    case t.SERP_REPORT_SNAPSHOT_PDF:
      return { ...state, reportSnapshotPdfLoading: true };
    case t.SERP_REPORT_SNAPSHOT_PDF_SUCCESS:
      return { ...state, reportSnapshotPdf: action.data, reportSnapshotPdfLoading: false };
    case t.SERP_REPORT_SNAPSHOT_PDF_FAIL:
      return { ...state, reportSnapshotPdfLoading: false };
    case t.SERP_REPORT_SNAPSHOT_PDF_RESET:
      return { ...state, reportSnapshotPdf: [] };

    case t.SERP_REPORT_EMAIL:
      return { ...state, reportEmailLoading: true };
    case t.SERP_REPORT_EMAIL_SUCCESS:
      return { ...state, reportEmail: action.data, reportEmailLoading: false };
    case t.SERP_REPORT_EMAIL_FAIL:
      return { ...state, reportEmailLoading: false };
    case t.SERP_REPORT_EMAIL_RESET:
      return { ...state, reportEmail: [] };

    // ---------- ITEM ----------
    case t.SERP_ITEM_LIST:
      return { ...state, itemListLoading: true };
    case t.SERP_ITEM_LIST_SUCCESS:
      return { ...state, itemList: action.data, itemListLoading: false };
    case t.SERP_ITEM_LIST_FAIL:
      return { ...state, itemListLoading: false };

    case t.SERP_ITEM_DATA:
      return { ...state, itemDataLoading: true };
    case t.SERP_ITEM_DATA_SUCCESS:
      return { ...state, itemData: action.data, itemDataLoading: false };
    case t.SERP_ITEM_DATA_FAIL:
      return { ...state, itemDataLoading: false };

    case t.SERP_ITEM_CREATE:
      return { ...state, itemCreateLoading: true };
    case t.SERP_ITEM_CREATE_SUCCESS:
      return { ...state, itemCreate: action.data, itemCreateLoading: false };
    case t.SERP_ITEM_CREATE_FAIL:
      return { ...state, itemCreateLoading: false };
    case t.SERP_ITEM_CREATE_RESET:
      return { ...state, itemCreate: [] };

    case t.SERP_ITEM_UPDATE:
      return { ...state, itemUpdateLoading: true };
    case t.SERP_ITEM_UPDATE_SUCCESS:
      return { ...state, itemUpdate: action.data, itemUpdateLoading: false };
    case t.SERP_ITEM_UPDATE_FAIL:
      return { ...state, itemUpdateLoading: false };
    case t.SERP_ITEM_UPDATE_RESET:
      return { ...state, itemUpdate: [] };

    case t.SERP_ITEM_DELETE:
      return { ...state, itemDeleteLoading: true };
    case t.SERP_ITEM_DELETE_SUCCESS:
      return { ...state, itemDelete: action.data, itemDeleteLoading: false };
    case t.SERP_ITEM_DELETE_FAIL:
      return { ...state, itemDeleteLoading: false };
    case t.SERP_ITEM_DELETE_RESET:
      return { ...state, itemDelete: [] };

    // ---------- SNAPSHOT ----------
    case t.SERP_SNAPSHOT_LIST:
      return { ...state, snapshotListLoading: true };
    case t.SERP_SNAPSHOT_LIST_SUCCESS:
      return { ...state, snapshotList: action.data, snapshotListLoading: false };
    case t.SERP_SNAPSHOT_LIST_FAIL:
      return { ...state, snapshotListLoading: false };

    case t.SERP_SNAPSHOT_DATA:
      return { ...state, snapshotDataLoading: true };
    case t.SERP_SNAPSHOT_DATA_SUCCESS:
      return { ...state, snapshotData: action.data, snapshotDataLoading: false };
    case t.SERP_SNAPSHOT_DATA_FAIL:
      return { ...state, snapshotDataLoading: false };

    case t.SERP_SNAPSHOT_DELETE:
      return { ...state, snapshotDeleteLoading: true };
    case t.SERP_SNAPSHOT_DELETE_SUCCESS:
      return { ...state, snapshotDelete: action.data, snapshotDeleteLoading: false };
    case t.SERP_SNAPSHOT_DELETE_FAIL:
      return { ...state, snapshotDeleteLoading: false };
    case t.SERP_SNAPSHOT_DELETE_RESET:
      return { ...state, snapshotDelete: [] };

    // ---------- RESULT ----------
    case t.SERP_RESULT_BY_SNAPSHOT:
      return { ...state, resultBySnapshotLoading: true };
    case t.SERP_RESULT_BY_SNAPSHOT_SUCCESS:
      return { ...state, resultBySnapshot: action.data, resultBySnapshotLoading: false };
    case t.SERP_RESULT_BY_SNAPSHOT_FAIL:
      return { ...state, resultBySnapshotLoading: false };

    case t.SERP_RESULT_BY_ITEM:
      return { ...state, resultByItemLoading: true };
    case t.SERP_RESULT_BY_ITEM_SUCCESS:
      return { ...state, resultByItem: action.data, resultByItemLoading: false };
    case t.SERP_RESULT_BY_ITEM_FAIL:
      return { ...state, resultByItemLoading: false };

    case t.SERP_RESULT_DATA:
      return { ...state, resultDataLoading: true };
    case t.SERP_RESULT_DATA_SUCCESS:
      return { ...state, resultData: action.data, resultDataLoading: false };
    case t.SERP_RESULT_DATA_FAIL:
      return { ...state, resultDataLoading: false };

    case t.SERP_RESULT_ORGANIC:
      return { ...state, resultOrganic: [], resultOrganicLoading: true };
    case t.SERP_RESULT_ORGANIC_SUCCESS:
      return { ...state, resultOrganic: action.data, resultOrganicLoading: false };
    case t.SERP_RESULT_ORGANIC_FAIL:
      return { ...state, resultOrganicLoading: false };
    case t.SERP_RESULT_ORGANIC_RESET:
      return { ...state, resultOrganic: [], resultOrganicLoading: false };

    default:
      return state;
  }
};

export default Serp;
